var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gongde-box-container" }, [
    _c("div", { staticClass: "box-border" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "back-btn", on: { click: _vm.handleBack } }, [
          _c("img", {
            attrs: {
              src: "https://fe-img.tengzhihh.com/image/bcef926966c12975fbb7e54c43d4cdeb-60x60.png",
              alt: "",
            },
          }),
        ]),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$route.meta.title)),
        ]),
        _c(
          "div",
          {
            staticClass: "explain",
            on: {
              click: function ($event) {
                return _vm.handleGuide(false)
              },
            },
          },
          [_vm._v("说明")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "main" },
        [
          _vm._m(0),
          _vm.serial_id
            ? [
                _vm.goodsDetail.goods && _vm.goodsDetail.goods.sku.length
                  ? _c(
                      "div",
                      { staticClass: "btns" },
                      _vm._l(_vm.goodsDetail.goods.sku, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "btn-item",
                            class: { active: _vm.skuPrice === item.price },
                            on: {
                              click: function ($event) {
                                return _vm.handleSku(item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "lianhua",
                              attrs: {
                                src: "https://fe-img.tengzhihh.com/image/9805c7dd77e948d94895b3d1fc1687a6-49x49.png",
                                alt: "",
                              },
                            }),
                            _c("div", { staticClass: "gongde" }, [
                              _vm._v(_vm._s(item.fu_de) + "功德值"),
                            ]),
                            _c("div", { staticClass: "price" }, [
                              _vm._v("￥" + _vm._s(item.price)),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _c("div", { staticClass: "input" }, [
                  _c("div", [_vm._v("自定义金额：")]),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.customPrice,
                          expression: "customPrice",
                          modifiers: { trim: true },
                        },
                      ],
                      attrs: { type: "text", inputmode: "numeric" },
                      domProps: { value: _vm.customPrice },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.customPrice = $event.target.value.trim()
                          },
                          _vm.handleInput,
                        ],
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" 元"),
                  ]),
                  _c("div", [_vm._v("（ " + _vm._s(_vm.gongde) + " 功德值）")]),
                ]),
                _c(
                  "div",
                  { staticClass: "submit", on: { click: _vm.handleSubmit } },
                  [_vm._v("布施")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: "https://fe-img.tengzhihh.com/image/e35dd8dd5ed1ca22a789fab082456f54-507x507.png",
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }